import ENDPOINT from "../endpoints";
import { HTTP_WORD } from "../http-common";

export function callGetWordOnline(payload) {
  return HTTP_WORD({
    url: ENDPOINT.WORD_ONLINE.GET,
    method: "GET",
    params: payload,
  });
}

export function callGetExcelOnline(payload) {
  return HTTP_WORD({
    url: `${ENDPOINT.EXCEL_ONLINE.GET}${payload.IdFile}`,
    method: "GET",
    params: {
      viewOnly: !!payload.Action
    },
  });
}

export function callAddVersion(payload) {
  return HTTP_WORD({
    url: ENDPOINT.WORD_ONLINE.ADD_VERSION,
    method: "POST",
    data: payload,
  });
}

export function callGetVersion(payload) {
  return HTTP_WORD({
    url: `/word/${payload}${ENDPOINT.WORD_ONLINE.GET_VERSION}`,
    method: "GET",
  });
}
